export class NodeLedger {
}
NodeLedger.RegisteredNodeNames = [];
NodeLedger.NameFormatter = (name) => name;
//# sourceMappingURL=nodeLedger.js.map